import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c481f26&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2c481f26&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c481f26",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c481f26')) {
      api.createRecord('2c481f26', component.options)
    } else {
      api.reload('2c481f26', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c481f26&scoped=true", function () {
      api.rerender('2c481f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/PersonalCenter/modules/TableData/index.vue"
export default component.exports